<template>
  <div class="pb-16 md:pb-40">
    <ContentContainer>
      <div class="rounded-md bg-gray-400 py-7 px-5 md:py-10 md:px-14 lg:py-20 lg:px-28">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-12">
          <div class="max-w-[630px]">
            <h4 class="text-black font-display text-[32px] md:text-[44px] xl:text-[56px] font-semibold">
              {{ $t('cta.industrialTitle') }}
            </h4>

            <p class="mt-6 font-body text-body-m md:min-h-[105px]">
              {{ $t('cta.industrialSubtitle') }}
            </p>

            <div class="mt-4">
              <ButtonPrimary to="/contact-us">
                {{ $t('cta.industrialBtnText') }}
              </ButtonPrimary>
            </div>
          </div>

          <div class="max-w-[630px]">
            <h4 class="text-black font-display text-[32px] md:text-[44px] xl:text-[56px] font-semibold">
              {{ $t('cta.partnersTitle') }}
            </h4>

            <p class="mt-6 font-body text-body-m md:min-h-[105px]">
              {{ $t('cta.partnersText')}}
            </p>

            <div class="mt-4">
              <ButtonPrimary to="/contact-us">
                {{ $t('cta.partnersBtnText') }}
              </ButtonPrimary>
            </div>
          </div>
        </div>
      </div>
    </ContentContainer>
  </div>
</template>
<script>
import ContentContainer from "@/components/ui/ContentContainer.vue";
import ButtonPrimary from "@/components/ui/ButtonPrimary.vue";

export default {
  components: {
    ButtonPrimary,
    ContentContainer,
  },
}
</script>
